import { store } from 'appSrc/redux/store';
import { facebookCheckLoginState } from 'appSrc/redux/actions';

class FacebookSDK {
    init( initConfig = {} ) {
        var { appId, debug } = initConfig;

        appId = appId || 'x';
        debug = debug || false;

        if( window.FB == undefined ) {
            window.fbAsyncInit = () => {
                FB.init({
                    appId            : appId,
                    autoLogAppEvents : true,
                    xfbml            : true,
                    version          : 'v5.0',
                });

                FB.loaded = true;

                store.dispatch( facebookCheckLoginState() );
                document.dispatchEvent( new Event('fb_init') );
            };

            var src = 'https://connect.facebook.net/en_US/sdk.js';
            if( debug ) {
                src = 'https://connect.facebook.net/en_US/sdk/debug.js';
            }

            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = src;
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    }
}

export const Facebook = new FacebookSDK();
